// import React, { useContext, useEffect, useRef, useState } from "react";
// import { io } from "socket.io-client";
// import { toast } from "react-toastify";
// import {
//   getOrderChangeStatus,
//   getOrderList,
//   getOrderListForSocket,
//   orderStatusAction,
// } from "../redux/actions/orderAction";
// import { useDispatch, useSelector } from "react-redux";
// import { orderListAction } from "../redux/actions/productAction";
// import audio from "../assets/audio.mp3";
// import { SocketContext } from "./socket-context";
// // var audio= new Audio("https://res.cloudinary.com/jangan-connect/video/upload/v1670754372/background/bell_udwffk.wav")
// // const SOCKET_SERVER_URL = 'https://bayin.app:4000';
// const SoundSocket = (data) => {
//   const audioRef = useRef(null);
//   // const beepsound = new Audio(audio);
//   // const socketRef = useRef();
//   const dispatch = useDispatch();
//   // const [audioPlayed, setAudioPlayed] = useState(false);
//   const userdata = JSON.parse(localStorage.getItem("ownerLogin"));
//   const { orderListData } = useSelector((state) => state.product);
//   const getActivePage = JSON?.parse(localStorage?.getItem("activePage"));
//   const finalData = JSON.parse(localStorage.getItem("finalData"));
//   const searchLocal = JSON?.parse(localStorage?.getItem("localSearch"));
//   const searchStartDate = JSON?.parse(localStorage?.getItem("localstartDate"));
//   const searchEndDate = JSON?.parse(localStorage?.getItem("localendDate"));
//   const searchStatus = JSON?.parse(localStorage?.getItem("localendDate"));
//   const socket = useContext(SocketContext);
//   const [resultData, setResultData] = useState([]);



// const isRunningRef = useRef(false);
// const processedIdsRef = useRef(new Set());

// useEffect(() => {
//   const callApi = async () => {
//     if (isRunningRef.current) return;
//     isRunningRef.current = true;

//     try {
//       const res = await dispatch(getOrderListForSocket());
//       if (res?.status === 200) {
//         const list = res?.data?.result || [];
//         setResultData(list);

//         const newOrders = list.filter(
//           (item) =>
//             item.status === "Received" &&
//             !processedIdsRef.current.has(item._id)
//         );

//         for (const order of newOrders) {
//           processedIdsRef.current.add(order._id);

//           await dispatch(
//             orderStatusAction({
//               orderId: order._id,
//               status: "Preparing",
//             })
//           );
//         }
//       }
//     } catch (err) {
//       console.log("API ERROR:", err);
//     } finally {
//       isRunningRef.current = false;
//     }
//   };

//   callApi();
//   const intervalId = setInterval(callApi, 10000);

//   return () => clearInterval(intervalId);
// }, []);





//   // useEffect(() => {
//   //   if(userdata?._id){
//   //     console.log("userdata",userdata);

//   //     socket.on('connect', () => {
//   //       console.log('Socket connected successfully!, userdata?._id ', userdata?._id )
//   //     });
//   //     socket.emit('room_join', { roomId:userdata?._id});
//   //     socket.on('room_join', (data) => {
//   //       console.log('datanewroomJOin', data);
//   //     })
//   //     socket.on('sendOrder', (data) => {
//   //       console.log('datanew', data);
//   //       dispatch(orderListAction({search :"",status :"",startDate : "",endDate:""}));
//   //       toast.success("New orfdgfghder received.", {
//   //         position: toast.POSITION.TOP_RIGHT,
//   //         autoClose: 3500,
//   //       });

//   //         // beepsound.play();

//   //     })

//   //     // socketRef.current.on('disconnect', (reason) => {
//   //     //   console.log(`Socket disconnected: ${reason}`);
//   //     // });
//   //   }
//   //   return () => {
//   //     socket.disconnect();
//   //   };
//   // }, [userdata]);

//   useEffect(() => {
//     if (resultData?.total > finalData?.total && data.flag === false) {
//       toast.success("New order received.", {
//         position: toast.POSITION.TOP_RIGHT,
//         autoClose: 3500,
//       });
//       const beepsound = new Audio(audio);

//       beepsound.play();

//       setTimeout(() => {
//         beepsound.pause();
//       }, 10000);
//     }
//   }, [orderListData]);

//   useEffect(() => {
//     if (orderListData?.total)
//       if (orderListData?.total) {
//         // setInterval(()=>{
//         console.log("orderListData?.total");
//         if (orderListData?.total !== 0) {
//           console.log("orderListData?.total !== 0");
//           localStorage.setItem("finalData", JSON.stringify(orderListData));
//         }
//       }
//   }, [orderListData]);
//   // return socketRef.current;

//   return (
//     <div>
//       {/* <audio ref={audioRef} >
//     <source src={beepsound} type="audio/mp3" />
//   </audio> */}
//     </div>
//   );
// };

// export default SoundSocket;

// // import React, { useEffect, useRef } from 'react'
// // import  {io} from 'socket.io-client';
// // // import  Audio from "../assets/audio/audio.mp3";
// // import { toast } from "react-toastify";
// // import { orderListAction } from '../redux/actions/productAction';
// // import { useDispatch } from 'react-redux';
// // // var audio= new Audio("https://res.cloudinary.com/jangan-connect/video/upload/v1670754372/background/bell_udwffk.wav")
// // const SOCKET_SERVER_URL = 'https://bayin.app:4000';
// // const SoundSocket = () => {
// //     const audioRef = useRef(null);
// //     const socketRef = useRef();
// //     const dispatch=useDispatch();

// //   useEffect(() => {
// //     socketRef.current = io(SOCKET_SERVER_URL, {
// //       transports: ['websocket'],
// //       reconnection: true,
// //       reconnectionAttempts: Infinity,
// //       reconnectionDelay: 1000,
// //       reconnectionDelayMax: 5000,
// //       randomizationFactor: 0.5,
// //     });

// //     socketRef.current.on('connect', () => {
// //       console.log('Socket connected successfully!');
// //       socketRef.current.emit('room_join', { roomId: userdata?._id  });
// //     });

// //     socketRef.current.on('sendOrder', (data) => {
// //       console.log('datanew', data);
// //       dispatch(orderListAction({ orderType: "pending" }));
// //       toast.success(data.text, {
// //         position: toast.POSITION.TOP_RIGHT,
// //         autoClose: 1000,
// //       });

// //       if (audioRef.current) {
// //         audioRef.current.play();
// //       }
// //       setTimeout(() => {
// //         if (audioRef.current) {
// //           audioRef.current.pause();
// //           audioRef.current.currentTime = 0;
// //         }
// //       }, 5000);
// //     })

// //     socketRef.current.on('disconnect', (reason) => {
// //       console.log(`Socket disconnected: ${reason}`);
// //     });

// //     return () => {
// //       socketRef.current.disconnect();
// //     };
// //   }, []);

// //   // return socketRef.current;

// //   return (
// //     <></>
// //   //   <audio ref={audioRef} >
// //   //   <source src={Audio} type="audio/mp3" />
// //   // </audio>
// //   )
// // }

// // export default SoundSocket


import React, { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import {
  getOrderListForSocket,
  orderStatusAction,
} from "../redux/actions/orderAction";
import { useDispatch, useSelector } from "react-redux";
import audio from "../assets/audio.mp3";
import { SocketContext } from "./socket-context";
import { orderListAction } from "../redux/actions/productAction";
import { isLoggedIn } from "../utils";

const SoundSocket = (data) => {
  const dispatch = useDispatch();
  const socket = useContext(SocketContext);

  const [resultData, setResultData] = useState([]);

  // FIX 1: useRef must be outside useEffect
  const isRunningRef = useRef(false);
  const processedIdsRef = useRef(new Set());

  const userdata = JSON.parse(localStorage.getItem("ownerLogin"));
  const { orderListData } = useSelector((state) => state.product);

  const finalData = JSON.parse(localStorage.getItem("finalData")) || { total: 0 };
    const { autoAccept } = useSelector((state) => state.store);
  
  // 🟢 AUTO ORDER FETCH + AUTO STATUS UPDATE
 const autoAcceptRef = useRef(false);
 useEffect(() => {
  autoAcceptRef.current = autoAccept;
}, [autoAccept]);

useEffect(() => {

  const callApi = async () => {
      let isLogged=isLoggedIn("ownerLogin")
   if (!isLogged) return;
    if (isRunningRef.current) return;
    isRunningRef.current = true;

    try {
      const res = await dispatch(getOrderListForSocket());

      if (res?.status === 200) {
        const list = res?.data?.result || [];
        setResultData(list);

        // 🔔 new received orders (sound logic)
        const newOrders = list.filter(
          (item) =>
            item.status === "Received" &&(item.paymentStatus==="authorized"||item.paymentStatus==="paid")&&
            !processedIdsRef.current.has(item._id)
        );

        // 🔔 sound should play whenever new order arrives
        if (newOrders.length > 0) {
          new Audio(audio).play();
        }

        // 🔁 auto status update ONLY when autoAccept is TRUE
        if (autoAcceptRef.current) {
          for (const order of newOrders) {
            processedIdsRef.current.add(order._id);

            await dispatch(
              orderStatusAction({
                orderId: order._id,
                status: "Preparing",
              })
            );
          }
        }
      }
    } catch (err) {
      console.error("API ERROR:", err);
    } finally {
      isRunningRef.current = false;
    }
  };

  // initial call
  callApi();

  // polling
  const intervalId = setInterval(callApi, 10000);

  return () => clearInterval(intervalId);
}, []);

  // 🟢 PLAY SOUND WHEN TOTAL INCREASES (SAFE VERSION)
  useEffect(() => {
    if (!orderListData?.total) return;

    const previousTotal = finalData?.total || 0;
    const currentTotal = orderListData?.total;

    if (currentTotal > previousTotal) {
      toast.success("New order received!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3500,
      });

      // const beep = new Audio(audio);
      // beep.play();
    }

    // update localStorage safely
    localStorage.setItem("finalData", JSON.stringify(orderListData));
  }, [orderListData]);

  // 🟢 SOCKET MESSAGE (SAFE)
  useEffect(() => {
    if (!socket || !userdata?._id) return;

    socket.on("connect", () => {
      // console.log("Socket connected:", userdata?._id);
    });

    socket.emit("room_join", { roomId: userdata?._id });

    socket.on("sendOrder", (data) => {
      // console.log("Socket new order:", data);

      // reload list
      dispatch(
        orderListAction({ search: "", status: "", startDate: "", endDate: "" })
      );

      toast.success("New order received!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3500,
      });

      const beep = new Audio(audio);
      beep.play();
    });

    return () => {
      socket.off("connect");
      socket.off("sendOrder");
    };
  }, [socket, userdata]);

  return <></>;
};

export default SoundSocket;
